import React, { ReactNode, useEffect } from "react";
import posthog from "posthog-js";
import {
  POSTHOG_ACTIVE,
  POSTHOG_HOST,
  POSTHOG_PROJECT_TOKEN,
} from "src/app.config";

import { PostHogProvider } from "@posthog/react";
import { resolveUserKey } from "@utils/analytics";

const isPostHogActive = POSTHOG_ACTIVE;

if (typeof window !== "undefined" && isPostHogActive) {
  posthog.init(POSTHOG_PROJECT_TOKEN, {
    api_host: POSTHOG_HOST,
    autocapture: true,
    // keep exception tracking
    capture_exceptions: true,
    capture_pageleave: true,
    capture_pageview: true,
    // turn off performance and heatmaps
    capture_performance: false,

    disable_session_recording: true,

    disable_surveys: true,
    enable_heatmaps: false,

    person_profiles: "identified_only",
  });
}

interface PostHogProviderWrapperProps {
  children: ReactNode;
}

export const PostHogProviderWrapper: React.FC<PostHogProviderWrapperProps> = ({
  children,
}) => {
  useEffect(() => {
    if (!isPostHogActive) return;
    const userKey = resolveUserKey();
    if (
      userKey &&
      !userKey.includes("@") &&
      typeof posthog.get_distinct_id === "function" &&
      posthog.get_distinct_id() !== userKey
    ) {
      try {
        posthog.identify(userKey);
      } catch (error) {
        console.warn(
          "Failed to identify user on PostHog provider mount:",
          error
        );
      }
    }
  }, []);

  if (!isPostHogActive) {
    return <>{children}</>;
  }

  return <PostHogProvider client={posthog}>{children}</PostHogProvider>;
};
